import constants from './constants';

const initialState = {
  buttonState: 'disabled',
};

export default function(state = initialState, action) {
  const { type, buttonState } = action;
  switch (type) {
    case constants.SET_BUTTON_STATE:
      return { buttonState };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/Button/reducer.js